<div class="container-border">
  <microsec-loading-overlay [isLoading]="!!isLoading">
    <microsec-selected-panel-header
      [id]="assessment?.id"
      [label]="assessment?.name"
      (closeSelectedPanelEvent)="hideDetailsPanel($event)"
      [rightTemplate]="rightTemplate" />
    <ng-template #rightTemplate>
      <div class="flex flex-row items-center gap-2">
        <p-button
          *ngIf="
            assessment?.status === ASSESSMENT_STATUS.COMPLETED &&
            assessment?.report_status !== ASSESSMENT_REPORT_STATUS.COMPLETED &&
            (!!permissions[USER_ROLE.TECHNICIAN] || currentUser?.id === assessment?.assignee_user_id)
          "
          icon="fas fa-circle-notch fa-spin"
          pTooltip="Processing"
          tooltipPosition="bottom"
          appendTo="body"
          severity="success"
          [disabled]="true" />
        <p-button
          *ngIf="
            assessment?.status === ASSESSMENT_STATUS.COMPLETED &&
            assessment?.report_status === ASSESSMENT_REPORT_STATUS.COMPLETED &&
            (!!permissions[USER_ROLE.TECHNICIAN] || currentUser?.id === assessment?.assignee_user_id)
          "
          icon="fas fa-clipboard-list"
          pTooltip="View Result"
          tooltipPosition="bottom"
          appendTo="body"
          severity="success"
          (onClick)="openAssessmentReport()" />
        <div [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
          <p-button
            [severity]="$any(assessment?.status === ASSESSMENT_STATUS.OPEN ? 'secondary' : 'warning')"
            icon="fas fa-play"
            [pTooltip]="assessment?.status === ASSESSMENT_STATUS.OPEN ? 'Start' : 'Resume'"
            tooltipPosition="bottom"
            appendTo="body"
            [disabled]="!isValidLicense()"
            (onClick)="execute()"
            *ngIf="
              assessment?.status !== ASSESSMENT_STATUS.COMPLETED &&
              (!!permissions[USER_ROLE.TECHNICIAN] || currentUser?.id === assessment?.assignee_user_id)
            " />
        </div>
        <div [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
          <p-button
            severity="primary"
            icon="fas fa-edit"
            pTooltip="Edit"
            tooltipPosition="bottom"
            appendTo="body"
            [disabled]="!isValidLicense()"
            (onClick)="openAssessmentForm()"
            *ngIf="assessment?.status === ASSESSMENT_STATUS.OPEN && !!permissions[USER_ROLE.TECHNICIAN]" />
        </div>
        <p-button
          severity="danger"
          icon="fas fa-trash"
          pTooltip="Delete"
          tooltipPosition="bottom"
          appendTo="body"
          (onClick)="openDeleteConfirmation()"
          *ngIf="!!permissions[USER_ROLE.TECHNICIAN]" />
      </div>
    </ng-template>
    <microsec-card [isDetailCard]="true">
      <p-tabs class="microsec-dashboard-tab" [value]="0">
        <p-tablist>
          <p-tab [value]="0">Overview</p-tab>
          @if (!!devices.length) {
            <p-tab [value]="1">Devices</p-tab>
          }
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="0">
            <app-assessment-overview [assessment]="assessment" />
          </p-tabpanel>
          @if (!!devices.length) {
            <p-tabpanel [value]="1">
              <app-shared-assessment-devices mode="assessment_detail_device" [isAllDevicesInit]="true" [devices]="devices" />
            </p-tabpanel>
          }
        </p-tabpanels>
      </p-tabs>
    </microsec-card>
  </microsec-loading-overlay>
</div>
